export default __webpack_public_path__ + "static/media/boton_banrural.f33fbd90.png";